// extracted by mini-css-extract-plugin
export default {"row":"EditName_row__QxBEO","title":"EditName_title__5TN6c","countryIcon":"EditName_countryIcon__Q3jdA","errorMessage":"EditName_errorMessage__YiYCg"};